import React from "react";
import { Helmet } from "react-helmet";

function Meta({ title, description, keywords, image }) {
  const metaTitle = title || "ALGermanist";
  const metaDescription =
    description ||
    "ALGermanist helps learners study German with structured courses and expert guidance.";
  const metaKeywords = keywords || "ALGermanist, German learning, language courses";
  const metaImage = image || "/al-germanist-logo.png";

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />

      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:site_name" content="ALGermanist" />
      <meta property="og:image" content={metaImage} />
    </Helmet>
  );
}

export default Meta;
